
<template>
  <div class="wrap-menu">

    <div class="content">
      <!-- 搜索 -->
      <div class="search" @click="searchVisible = true">
        <img src="/images/preloader/icon_foot_search.png" alt="">
        <div class="text">搜寻目的地</div>
      </div>
      <!-- 功能模块 -->
      <ul class="func-list">
        <template v-for="(item,index) in funModule">
          <li v-if="item.checked" :key="index" @click="$emit('selectMenuModule',item.code)">
            <div v-if="$store.state.app.isPortrait" class="func-text" :class="getItemClass(item.value)">
              {{ item.value ==='查症状'? '智能导诊':item.value }}
            </div>
            <!-- <img v-else :src="'/images/preloader/funModule/' + item.img" alt=""> -->
            <img v-else :src="isUseImg(item.img)" alt="">
          </li>
        </template>
      </ul>
      <!-- 二维码 -->
      <ercodeBlock v-if="!$store.state.app.isPortrait"></ercodeBlock>
    </div>

    <search v-if="searchVisible" @return="searchVisible = false" @search="search"></search>
  </div>

</template>

<script>
import search from '@/components/search';
import ercodeBlock from './ercode-block.vue';
export default {
  components: {
    search,
    ercodeBlock
  },
  props: {
    isShowCopyRight: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      searchVisible: false
    };
  },
  computed: {
    // 建筑信息
    buildInfo: {
      get () { return this.$store.state.nav.buildInfo; },
      set (val) { this.$store.commit('nav/set_buildInfo', val); }
    },
    qrcodeUrl () {
      return this.$store.state.app.qrcodeUrl;
    },
    buildLogo () {
      return this.$store.state.nav.buildLogo;
    },
    // 功能权限
    funModule () {
      let basiSetting = this.$store.state.app.baseSettingInfo.basiSetting;
      console.log('basiSetting', basiSetting);
      return basiSetting && basiSetting.funModule ? JSON.parse(basiSetting.funModule) : [];
    },
    showCopyRight () {
      return this.isShowCopyRight;
    }
  },
  async created () {
    console.log('功能权限：', this.funModule);
  },
  mounted () {
  },
  methods: {
    isUseImg (img) {
      if (img.indexOf('.png') > -1) {
        return '/images/preloader/funModule/' + img;
      } else {
        return img;
      }
    },
    getItemClass (name) {
      let classNames = {
        '找科室': 'zks',
        '找专家': 'zzj',
        '查楼栋': 'cld',
        '查症状': 'czz',
        '医院资讯': 'yyzx',
        '医院介绍': 'yyjs'
      };
      return classNames[name];
    },
    search (key) {
      this.$emit('search', key);
    },
    // 关闭el-image遮罩层
    handleClickItem () {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector('.el-image-viewer__mask');
        if (!domImageMask) {
          return;
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click();
        });
      });
    }
  }
};
</script>

<style scoped lang="scss">
@media (orientation: landscape) {
.wrap-menu {
  padding: 20px 20px 20px 0;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  .content {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 20px;
    background: $color-opacity-primary;
    padding: 20px;
    box-sizing: border-box;
  }
  .search {
    display: flex;
    width: 100%;
    height: 50px;
    align-items: center;
    border-radius: 30px;
    background: rgba(60, 110, 126, 0.8);
    img {
      margin: 0 20px 0 30px;
      width: 20px;
    }
    .text {
      font-size: 20px;
      color: $color-white;
    }
  }
  .func-list {
    display: flex;
    flex-wrap: wrap;
    margin: 10px 0;
    // margin: 15px -40px 25px 0;
    // height: 280px;
    li {
      width: 33.3333%;
      // margin: 0 30px 0 0;
      font-size: 0;
      // height: 140px;
      padding: 8px;
      box-sizing: border-box;
    }
    img {
      width: 100px;
      height: 100px;
    }
  }

}
.m-b-8 {
  margin-bottom: 8px;
}
@media screen and (max-width: 1446px) {
    .func-list {
      margin: 10px 0 !important;
      // margin: 15px -40px 25px 0;
      // height: 280px;
      img {
        width: 100% !important;
        height: 100% !important;
      }
    }
    .search {
      height: 40px !important;
      img {
        width: 16px  !important;
      }
      .text {
        font-size: 16px !important;
      }
    }
  }
}

@media (orientation: portrait) {
  .wrap-menu {
  padding: 0;
  box-sizing: border-box;
  width: 37.04vw;
  height: 100%;
  .content {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 1.48vw;
    background: $color-opacity-primary;
    padding: 2.96vw;
    box-sizing: border-box;
  }
  .search {
    display: flex;
    width: 100%;
    height: 6.67vw;
    align-items: center;
    border-radius: 0.56vw;
    background: rgba(60, 110, 126, 0.8);
    // border: 1px solid #fff;
    padding: 1.67vw 2.22vw;
    box-sizing: border-box;
    img {
      margin: 0 1.85vw 0 2.78vw;
      width: 2.96vw;
      height: 2.96vw;
    }
    .text {
      font-size: 2.41vw;
      color: $color-white;
      margin-left: 0.46vw;
    }
  }
  .func-list {
    display: flex;
    flex-wrap: wrap;
    padding-top: 2.22vw;
    box-sizing: border-box;
    li {
      box-sizing: border-box;
      color: #fff;
      margin-bottom: 2.22vw;
      .func-text {
        display: block;
        border-radius: 0.74vw;
        width: 14.44vw;
        height: 7.41vw;
        line-height: 7.41vw;
        font-size: 2.41vw;
      }
    }
    li:nth-of-type(odd){
      margin-right: 2.22vw;
    }
    img {
      width: 277px;
      height: 4.16vh;
    }
  }
}
.m-b-8 {
  margin-bottom: 8px;
}
}
.zks{
  background: linear-gradient( 180deg, #FFB83C 0%, #E87402 100%);
  border-radius: 14px;
}
.zzj{
  background: linear-gradient( 180deg, #F475A1 0%, #CC3267 100%);
  border-radius: 14px;
}
.cld{
  background: linear-gradient( 180deg, #19C8FA 0%, #048AE8 100%);
  border-radius: 14px;
}
.czz{
  background: linear-gradient( 180deg, #A08FFC 0%, #6C5CED 100%);
  border-radius: 14px;
}
.yyzx{
  background: linear-gradient( 180deg, #2DD79A 0%, #0C9962 100%);
  border-radius: 14px;
}
.yyjs{
  background: linear-gradient( 180deg, #F79D6D 0%, #F3602E 100%);
  border-radius: 14px;
}

</style>
